export default __webpack_public_path__ + "static/media/banner-franquia-interesse.f83023f6.png";